import React, { createContext, useContext, useState } from "react";
import { ProbateField } from "./models/ProbateField";
import { STORAGE } from "./constants";
import { AuthContext } from "./AuthContextWrapper";
interface Props {
  children: JSX.Element;
}

export interface ProbateContextInterface {
  saveFieldAnswered?: (field: ProbateField) => void;
  getFieldsAnswered?: () => ProbateField[] | undefined;
  clearFieldsAnswered?: () => void;
}

export const ProbateContext = createContext<ProbateContextInterface>({
  saveFieldAnswered: () => undefined,
  getFieldsAnswered: () => undefined,
  clearFieldsAnswered: () => undefined,
});

export const ProbateContextWrapper = ({ children }: Props): JSX.Element => {
  const { user, activeEstate } = useContext(AuthContext);

  const [fieldsAnswered, setFieldsAnswered] = useState<ProbateField[]>([]);
  const fieldsAnsweredStorageItem = `${STORAGE.fieldsAnswered}-${user?.id}-${activeEstate?.stateId}`;

  const getFieldsAnswered = (): ProbateField[] => {
    let fields: ProbateField[] = [];
    const savedFieldsAnswered = window.localStorage.getItem(
      fieldsAnsweredStorageItem
    );
    if (savedFieldsAnswered) {
      fields = JSON.parse(savedFieldsAnswered)?.map((object: any) =>
        ProbateField.fromStringified(object)
      );
      setFieldsAnswered(fields);
    }
    return fields;
  };

  const saveFieldAnswered = (probateField: ProbateField): void => {
    const foundField = fieldsAnswered.find((answeredField: ProbateField) => {
      return answeredField.id === probateField.id;
    });
    if (!foundField) {
      const newFieldsAnswered = [...fieldsAnswered, probateField];
      setFieldsAnswered(newFieldsAnswered);
      window.localStorage.setItem(
        fieldsAnsweredStorageItem,
        JSON.stringify(newFieldsAnswered)
      );
    }
  };

  const clearFieldsAnswered = (clearStorage = true): void => {
    setFieldsAnswered([]);
    clearStorage && window.localStorage.removeItem(fieldsAnsweredStorageItem);
  };

  return (
    <ProbateContext.Provider
      value={{
        saveFieldAnswered,
        getFieldsAnswered,
        clearFieldsAnswered,
      }}
    >
      {children}
    </ProbateContext.Provider>
  );
};
